var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanActiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3346 2.33594H4.66797V25.6693H23.3346V2.33594ZM7.0013 4.66927H12.8346V14.0026L9.91797 12.2526L7.0013 14.0026V4.66927Z",
    fill: "#ff3f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanActiveIcon);
export default __webpack_public_path__ + "static/media/planActiveIcon.9fb3d2b3e53450fc48e01591be2d9633.svg";
export { ForwardRef as ReactComponent };